import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { insuranceActions } from "../../../../store/insurance"
import TabHeader from "../../tab/TabHeader"
import NotesComponent from "../notes/NotesComponent"
import LiabilityTabControls from "../liability/LiabilityTabControls"
import MajorMedDetails from "./MajorMedDetails"
import ItemsCounter from "../Shared/ItemsCounter"
const MajorMedTab = ({ inWorkQ }) => {    
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(insuranceActions.setSearchResult(null))
            dispatch(insuranceActions.setClearAsyncResults(false))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Major Med</h2>
                <ItemsCounter type={'major_meds'}/>
                <NotesComponent noteTypeId={7} inWorkQ={inWorkQ}/>
            </div>
            <LiabilityTabControls folder={'major_meds'} apiCase={'case_major_med'}/>
        </TabHeader>
        <div>
            <MajorMedDetails />
        </div>
    </>
}

export default MajorMedTab